// key-storage-web.service.ts
import { Injectable } from '@angular/core';
import { IKeyStorage }  from '../crypto/key-manager';

@Injectable()
export class KeyStorageWebService implements IKeyStorage {
  
  private readonly WRAPPED_ID = 'wrapped_aes_key';
  private readonly PRIV_KEY_ID = 'device_private_key';
  private readonly PUB_KEY_ID = 'device_public_key';
  private readonly DB_NAME = 'secure_keys_db';
  private readonly STORE_NAME = 'keys';
  
  private db: IDBDatabase | null = null;
  
  async saveWrappedKey(wrappedKeyB64: string): Promise<void> {
    await this.ensureDb();
    return new Promise((resolve, reject) => {
      const tx = this.db!.transaction([this.STORE_NAME], 'readwrite');
      const store = tx.objectStore(this.STORE_NAME);
      const request = store.put(wrappedKeyB64, this.WRAPPED_ID);
      
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  }
  
  async getWrappedKey(): Promise<string | null> {
    await this.ensureDb();
    return new Promise((resolve, reject) => {
      const tx = this.db!.transaction([this.STORE_NAME], 'readonly');
      const store = tx.objectStore(this.STORE_NAME);
      const request = store.get(this.WRAPPED_ID);
      
      request.onsuccess = () => resolve(request.result || null);
      request.onerror = () => reject(request.error);
    });
  }
  
  async savePrivateKey(privateKey: CryptoKey): Promise<void> {
    await this.ensureDb();
    return new Promise((resolve, reject) => {
      const tx = this.db!.transaction([this.STORE_NAME], 'readwrite');
      const store = tx.objectStore(this.STORE_NAME);
      const request = store.put(privateKey, this.PRIV_KEY_ID);
      
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  }
  
  async getPrivateKey(): Promise<CryptoKey | null> {
    await this.ensureDb();
    return new Promise((resolve, reject) => {
      const tx = this.db!.transaction([this.STORE_NAME], 'readonly');
      const store = tx.objectStore(this.STORE_NAME);
      const request = store.get(this.PRIV_KEY_ID);
      
      request.onsuccess = () => resolve(request.result || null);
      request.onerror = () => reject(request.error);
    });
  }

 async savePublicKey(publicKeySpki: CryptoKey): Promise<void> {
    await this.ensureDb();
    return new Promise((resolve, reject) => {
      const tx = this.db!.transaction([this.STORE_NAME], 'readwrite');
      const store = tx.objectStore(this.STORE_NAME);
      const request = store.put(publicKeySpki, this.PUB_KEY_ID);
      
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  }
  
  async getPublicKey(): Promise<CryptoKey | null> {
    await this.ensureDb();
    return new Promise((resolve, reject) => {
      const tx = this.db!.transaction([this.STORE_NAME], 'readonly');
      const store = tx.objectStore(this.STORE_NAME);
      const request = store.get(this.PUB_KEY_ID);
      
      request.onsuccess = () => resolve(request.result || null);
      request.onerror = () => reject(request.error);
    });
  }


  
  async clear(): Promise<void> {
    await this.ensureDb();
    return new Promise((resolve, reject) => {
      const tx = this.db!.transaction([this.STORE_NAME], 'readwrite');
      const store = tx.objectStore(this.STORE_NAME);
      
      store.delete(this.WRAPPED_ID);
      store.delete(this.PRIV_KEY_ID);
      store.delete(this.PUB_KEY_ID);  // ✅ Added
      
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
    });
  }
    async deleteWrappedKey(): Promise<void> {
      const tx = this.db!.transaction([this.STORE_NAME], 'readwrite');
      const store = tx.objectStore(this.STORE_NAME);
   store.delete(this.WRAPPED_ID);
    console.log('🗑️ Wrapped key deleted (native)');
  }


  private async ensureDb(): Promise<void> {
    if (this.db) return;
    
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.DB_NAME, 1);
      
      request.onerror = () => reject(request.error);
      request.onsuccess = () => {
        this.db = request.result;
        resolve();
      };
      
      request.onupgradeneeded = (event: any) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(this.STORE_NAME)) {
          db.createObjectStore(this.STORE_NAME);
        }
      };
    });
  }
}